module.exports = __webpack_public_path__ + "static/media/m3tj0.90053d5f.png";